// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-spinner {
  color: var(--accent-color);
  margin-top: 40px;
}

.legal-html {
  max-width: 800px;
  margin: 0 auto;
  padding: 8px 0 40px;
}
.legal-html ::ng-deep h1,
.legal-html ::ng-deep h2,
.legal-html ::ng-deep h3,
.legal-html ::ng-deep h4,
.legal-html ::ng-deep h5,
.legal-html ::ng-deep h6 {
  margin: 28px 0 10px;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 600;
  text-transform: none;
  color: var(--accent-color) !important;
}
@media (min-width: 991px) {
  .legal-html ::ng-deep h1,
  .legal-html ::ng-deep h2,
  .legal-html ::ng-deep h3,
  .legal-html ::ng-deep h4,
  .legal-html ::ng-deep h5,
  .legal-html ::ng-deep h6 {
    font-size: 20px;
  }
}
.legal-html ::ng-deep h1 strong,
.legal-html ::ng-deep h2 strong,
.legal-html ::ng-deep h3 strong,
.legal-html ::ng-deep h4 strong,
.legal-html ::ng-deep h5 strong,
.legal-html ::ng-deep h6 strong {
  color: inherit !important;
  font-weight: inherit;
}
.legal-html ::ng-deep h1:first-child,
.legal-html ::ng-deep h2:first-child,
.legal-html ::ng-deep h3:first-child,
.legal-html ::ng-deep h4:first-child,
.legal-html ::ng-deep h5:first-child,
.legal-html ::ng-deep h6:first-child {
  margin-top: 0;
}
.legal-html ::ng-deep p,
.legal-html ::ng-deep li {
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
  color: #fff;
}
@media (min-width: 991px) {
  .legal-html ::ng-deep p,
  .legal-html ::ng-deep li {
    font-size: 16px;
  }
}
.legal-html ::ng-deep strong {
  font-weight: 600;
  color: #fff;
}
.legal-html ::ng-deep ul,
.legal-html ::ng-deep ol {
  padding-left: 20px;
  margin: 0 0 12px;
}
.legal-html ::ng-deep a {
  color: var(--accent-color);
  text-decoration: underline;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/components/legal-content/legal-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;AADD;;AAIA;EACC,0BAAA;EACA,gBAAA;AADD;;AAIA;EACC,gBAAA;EACA,cAAA;EACA,mBAAA;AADD;AAIE;;;;;;EAMC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qCAAA;AAFH;ACzBE;EDgBA;;;;;;IAcE,eAAA;EAIF;AACF;AAFG;;;;;;EACC,yBAAA;EACA,oBAAA;AASJ;AANG;;;;;;EACC,aAAA;AAaJ;AATE;;EAEC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAWH;AC5DE;ED2CA;;IASE,eAAA;EAaF;AACF;AAVE;EACC,gBAAA;EACA,WAAA;AAYH;AATE;;EAEC,kBAAA;EACA,gBAAA;AAWH;AARE;EACC,0BAAA;EACA,0BAAA;EACA,sBAAA;AAUH","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n}\n\nion-spinner {\n\tcolor: var(--accent-color);\n\tmargin-top: 40px;\n}\n\n.legal-html {\n\tmax-width: 800px;\n\tmargin: 0 auto;\n\tpadding: 8px 0 40px;\n\n\t::ng-deep {\n\t\th1,\n\t\th2,\n\t\th3,\n\t\th4,\n\t\th5,\n\t\th6 {\n\t\t\tmargin: 28px 0 10px;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 1.3;\n\t\t\tfont-weight: 600;\n\t\t\ttext-transform: none;\n\t\t\tcolor: var(--accent-color) !important;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\n\t\t\tstrong {\n\t\t\t\tcolor: inherit !important;\n\t\t\t\tfont-weight: inherit;\n\t\t\t}\n\n\t\t\t&:first-child {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\n\t\tp,\n\t\tli {\n\t\t\tmargin: 0 0 12px;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 1.6;\n\t\t\tfont-weight: 400;\n\t\t\tcolor: #fff;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 16px;\n\t\t\t}\n\t\t}\n\n\t\tstrong {\n\t\t\tfont-weight: 600;\n\t\t\tcolor: #fff;\n\t\t}\n\n\t\tul,\n\t\tol {\n\t\t\tpadding-left: 20px;\n\t\t\tmargin: 0 0 12px;\n\t\t}\n\n\t\ta {\n\t\t\tcolor: var(--accent-color);\n\t\t\ttext-decoration: underline;\n\t\t\tword-break: break-word;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
